// MENU NAVIGATION & CURRENT PAGE CLASS BEGIN
// Get the current page URL
const currentPageUrl = window.location.href;

// Get all the menu items
const menuItems = document.querySelectorAll('.header__menu-item');

// Loop through each menu item
menuItems.forEach(menuItem => {
  // Get the URL of the menu item
  const menuItemUrl = menuItem.href;

  // Check if the current page URL matches the menu item URL
  if (currentPageUrl === menuItemUrl) {
    // Add the "current-page" class to the menu item
    menuItem.classList.add('current-page');
  }
});

// Get the last segment of the URL (i.e., the page name)
const currentPageName = window.location.pathname.split('/').pop().split('.')[0];

// Sanitize the current page name
const sanitizedPageName = currentPageName.replace(/[^a-zA-Z0-9-]/g, '').replace(/\s+/g, '-');

// Add the sanitized page name as a class to the body element
if (sanitizedPageName) {
  document.body.classList.add(sanitizedPageName);
} else {
  document.body.classList.add('template-body');
}
// MENU NAVIGATION & CURRENT PAGE CLASS END


// FUNCTION TO REPLACE MENU TEXT TO LOGO BEGIN
function replaceTextWithLogo() {
  var elementToReplace = document.querySelector('.halo-sidebar_menu .halo-sidebar-header .title'); // Select the element with the class 'title'
  if (elementToReplace) {
    elementToReplace.innerHTML = '<a href="/" class="side-menu-logo"><img src="https://cdn.shopify.com/s/files/1/0746/8990/4917/files/favicon.png?v=1686031316" loading="lazy" width="50" height="38" alt="Zara Gul Studio"></a>';
  }
}

// Replace HTML on page load
document.addEventListener('DOMContentLoaded', replaceTextWithLogo);
// FUNCTION TO REPLACE MENU TEXT END

// SIDE MENU CONTACT INFO ADDED BEGIN
function insertContent() {
  $('<div class="side-menu-contact-info"> <a href="/pages/request-an-appointment" class="custom-button-style"> <span class="text p-relative">Request an appointment</span></a> <div class="hero-info"> <h6>Hours</h6> <p>Monday - Friday: <br>11am to 7:30 pm</p> </div> </div>').insertAfter('.site-nav-mobile.nav');
}

// Insert the content after the page is completely loaded
document.addEventListener('DOMContentLoaded', insertContent);
// SIDE MENU CONTACT INFO ADDED END

// HERO IMAGE SLIDER BEGIN
$(function () {
  $('#hero_image_slider').slick({
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: false,
      infinite: true,
      dots: true,
        fade: true,
        speed: 2000,        
        cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',    
      customPaging: function(slider, i) {
        var slideTitle = $(slider.$slides[i]).find("button").text();
        return '<span class="bespoke-dot">' + slideTitle + '</span>';        
      },      
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [{
          breakpoint: 1024,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
          }
      }]
  });
});
// HERO IMAGE SLIDER END

// SERVICES SLIDER BEGIN
$(function () {
    $('#services_slider').slick({
        autoplay: false,
        arrows: false,
        infinite: true,
        dots: true,
        speed: 1000,
        customPaging: function(slider, i) {
            var slideTitle = $(slider.$slides[i]).find("h2").text();
            return '<div class="slide-text-and-dot"><span class="slide-title">' + slideTitle + '</span><span class="slide-dot"></span></div>';        
        },
        centerMode: true,
        centerPadding: '20%',
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                centerPadding: '8%',
            }
        }]
    });
});
// SERVICES SLIDER END

// TESTIMONIALS SLIDER BEGIN
$(function () {
    $('#testimonials_slider').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true,
        infinite: true,
        dots: false,
        fade: true,
        speed: 2000,        
        cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                arrows: true,
            }
        }]
    });
});
// TESTIMONIALS SLIDER END

// ZG BEAUTY INFO AND VIDEO SLIDER BEGIN
$(function () {
    $('#zgbeauty_info_video_slider').slick({
        autoplay: false,
        arrows: true,
        infinite: true,
        dots: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                arrows: true,
            }
        }]
    });
});
// ZG BEAUTY INFO AND VIDEO SLIDER END

// ZG BEAUTY INFO AND VIDEO SLIDER BEGIN
$(function () {
    $('#zgbeauty_usp_slider').slick({
        autoplay: false,
        arrows: true,
        infinite: true,
        dots: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        customPaging : function(slider, i) {
          var slide = slider.$slides[i],
            pagination = $(slide).data('pagination');
          return '<div>' + pagination + '</div>';
        },
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                arrows: true,
            }
        }]
    });
});
// ZG BEAUTY INFO AND VIDEO SLIDER END

// VIDEO FULLSCREEN START 
var vid = document.getElementById("fullVideo");

function disableMute() {
  // Check if the video is currently muted
  if (jQuery(".video-wrapper video").prop('muted')) {
    // If muted, unmute the video
    jQuery(".video-wrapper video").prop('muted', false);
    jQuery(".video-wrapper button").addClass('unmute-video');

  } else {
    // If not muted, mute the video
    jQuery(".video-wrapper video").prop('muted', true);
    jQuery(".video-wrapper button").removeClass('unmute-video');
  }
}

var video = document.getElementById("fullVideo");

function playVid() {
  // Play the video
  video.play();
}

function pauseVid() {
  // Pause the video
  video.pause();
}

jQuery(window).on('load', function() {

    jQuery.fn.isOnScreen = function() {
      // Define a custom jQuery function to check if an element is visible on the screen
      var win = jQuery(window);
      var viewport = {
        top: win.scrollTop(),
        left: win.scrollLeft()
      };
      viewport.right = viewport.left + win.width();
      viewport.bottom = viewport.top + win.height();
      var bounds = this.offset();
      bounds.right = bounds.left + this.outerWidth();
      bounds.bottom = bounds.top + this.outerHeight();
      return (
        !(viewport.right < bounds.left ||
          viewport.left > bounds.right ||
          viewport.bottom < bounds.top ||
          viewport.top > bounds.bottom)
      );
    };

    jQuery(window).scroll(function() {
      // Attach a scroll event listener to the window

      if (jQuery('.video-wrapper').isOnScreen()) {
        // Check if the video wrapper is on the screen
        jQuery(".video-wrapper").addClass('video-wrapper-visible');
        playVid();
      } else {
        jQuery(".video-wrapper").removeClass('video-wrapper-visible');
        pauseVid();
      }
    });

});
// VIDEO FULLSCREEN END

// FOOTER SOCIALS OPEN IN NEW TAB START
// Get all the anchor tags within the footer block list
var footerLinks = document.querySelectorAll('.footer-block__link_list:nth-child(4) a');

// Add event listener to each anchor tag
footerLinks.forEach(function(link) {
  link.addEventListener('click', function(event) {
    // Prevent the default link behavior
    event.preventDefault();
    // Open the link in a new tab
    window.open(link.href, '_blank');
  });
});
// FOOTER SOCIALS OPEN IN NEW TAB END

// HOMEPAGE MOBILE MENU SCRIPT BEGIN
document.addEventListener('DOMContentLoaded', function () {
    // Check if we are on homepage
    if (!document.body.classList.contains('template-index')) return;

    const mobileToggle = document.querySelector('.mobileMenu-toggle');
    const menuMobile = document.querySelector('[data-navigation-mobile]');

    if (!mobileToggle || !menuMobile) return;

    // Function to load desktop nav into mobile menu
    function loadMobileNav() {
        const desktopNav = document.querySelector('#HeaderNavigation [data-navigation]');
        if (!desktopNav || !desktopNav.innerHTML.trim()) {
            // Retry after 100ms if nav not yet rendered
            setTimeout(loadMobileNav, 100);
            return;
        }

        // Remove previous mobile nav to avoid duplicates
        menuMobile.querySelectorAll('nav.header__inline-menu').forEach(el => el.remove());

        const style = desktopNav.getAttribute('style') || 
                      desktopNav.closest('#HeaderNavigation')?.getAttribute('style') || '';

        menuMobile.insertAdjacentHTML(
            'beforeend',
            `<nav class="header__inline-menu" data-navigation role="navigation" style="${style}">
                ${desktopNav.innerHTML}
            </nav>`
        );
    }

    // Handle hamburger click
    mobileToggle.addEventListener('click', function () {
        document.body.classList.toggle('menu_open');

        if (document.body.classList.contains('menu_open')) {
            loadMobileNav();
        } else {
            // Remove nav on menu close
            menuMobile.querySelectorAll('nav.header__inline-menu').forEach(el => el.remove());
        }
    });

    // Handle close icon
    document.addEventListener('click', function (e) {
        if (e.target.closest('.halo-sidebar-close[data-menu-close-sidebar]')) {
            document.body.classList.remove('menu_open');
            menuMobile.querySelectorAll('nav.header__inline-menu').forEach(el => el.remove());
        }
    });
});
// // HOMEPAGE MOBILE MENU SCRIPT END
